import React, { useState, useEffect } from "react";
import * as yup from "yup";
import styles from "./user_bookings.module.css";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Modal, Button, Row, Col, Spinner } from "react-bootstrap";
import ApiActions from "api_actions";
import MyToast from "components/toast/toast";
import PolicyCheckbox from "components/payment_form/submit_booking_button/policy_checkbox/policy_checkbox";
import Loading from "components/loading";
import buildPath from "utils/build_path";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import routes from "routing/routes";

export default function UserBookings({ showModal, setShowModal, userData }) {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const getBookings = async () => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("channel_id", userData?.channelId);
      formData.append("id", userData?.id);
      formData.append("type", userData?.login_type === "member" ? 0 : 1);

      const response = await ApiActions.getUserBookings(formData);

      if (response?.data?.data?.length > 0) {
        setBookings(response?.data?.data);
      } else {
        setBookings([]);
      }
      setLoading(false);
    } catch (e) {
      setBookings([]);
      setLoading(false);
    }
  };
  useEffect(() => {
    getBookings();
  }, []);

  const handleViewDetails = (booking) => {
    let confirmationNo = booking?.booking_code?.replace(
      /^(osa-|OSA-|hbe-|HBE-|GHA-|gha-|hpt-|HPT-)/i,
      "",
    );

    const queryParams = {
      channelId: userData?.channelId,
      confirmation_no: confirmationNo?.trim(),
    };
    setShowModal(false);

    const PagePath = buildPath(history.location.search, routes.updateBookingPage, queryParams);

    history.push(PagePath);
  };
  return (
    <>
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className={styles.title}>Bookings</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "50vw", overflow: "scroll" }}>
          <div className={styles.bookingList}>
            {loading ? <Spinner animation="border" size="sm" className={styles.spinner} /> : null}
            {bookings?.length === 0 && !loading ? (
              <>
                <div>No Bookings found</div>
              </>
            ) : (
              bookings?.map((booking) => (
                <div key={booking.id} className={styles.bookingItem}>
                  <div className={styles.bookingDetails}>
                    <div className={styles.bookingCode}>Booking Code: {booking?.booking_code}</div>
                    <div className={styles.bookingDates}>
                      Check-in: {booking?.check_in} | Check-out: {booking?.check_out}
                    </div>
                  </div>
                  <button
                    className={styles.viewDetailsButton}
                    onClick={() => handleViewDetails(booking)}
                  >
                    View Details
                  </button>
                </div>
              ))
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
